// Shared by the consent detail page and the records view.
import { OTHER_ORGS } from '../../constants/abdmCopy';

const ACTIVE_CONSENT_STATUSES = new Set(['GRANTED', 'ACTIVE']);

// Consent gate for the detail page AND the records page: the SERVER's word only (display_status),
// no client-clock expiry, so the list, detail and records page never disagree (QA D4/D5).
export const isServerActive = (consent) => !!consent && ACTIVE_CONSENT_STATUSES.has(consent.status)
  && consent.displayStatus !== 'EXPIRED';

// One entry per organisation (artefact) the patient shared. A consent without artefacts
// (older rows) is one unnamed entry on latestFetchId.
export function orgsOf(consent) {
  if (!consent) return [];
  if (!consent.artefacts || consent.artefacts.length === 0) {
    return [{
      artefactId: 'consent', hipName: null, isOwnOrganisation: false, latestFetchId: consent.latestFetchId || null,
      fetchStatus: consent.latestFetchId ? 'RECEIVED' : 'NOT_REQUESTED', recordsReceived: consent.recordsReceived,
      requestedAt: null, lastCheckedAt: null, failureReason: null,
    }];
  }
  return consent.artefacts;
}

export const orgLabel = (a) => (a.artefactId === 'consent' ? OTHER_ORGS.organisation : (a.hipName || a.hipId || OTHER_ORGS.organisation));

// Organisations whose records can be listed.
export const hasRecords = (a) => !a.isOwnOrganisation && !!a.latestFetchId
  && (a.fetchStatus === 'RECEIVED' || a.recordsReceived > 0);

// The one rule for the "Access until" line on the list row AND the detail page (FT-R7): every status
// shows it (the requested end of access, for Denied / Revoked / Expired too) except "Not sent",
// which never reached the patient.
export const showsAccessUntil = (status) => status !== 'SUBMIT_FAILED';

// Reason line for a "Not sent" consent (server submit_failure_code, e.g. ABDM_REJECTED); null when none/unknown.
// variant: 'list' (stands alone) or 'card' (inside the detail card, which adds the next step).
export const notSentReason = (consent, variant) => OTHER_ORGS.notSentReasons[consent.submitFailureCode]?.[variant] || null;
